import { Link } from 'react-router-dom';
import { Card } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { CheckCircle, Home, Bike, Mail } from 'lucide-react';

export const DeliverySuccess = () => {
  return (
    <div className="min-h-screen pt-20 bg-gray-50 flex items-center justify-center" data-testid="delivery-success-page">
      <div className="max-w-lg mx-auto px-4">
        <Card className="p-8 md:p-12 text-center">
          <div className="bg-yellow-100 text-[#FFD700] p-6 rounded-full inline-block mb-6">
            <CheckCircle className="w-16 h-16" />
          </div>
          
          <h1 className="text-3xl font-bold text-gray-900 mb-4" style={{ fontFamily: 'Outfit, sans-serif' }}>
            Application Complete!
          </h1>
          
          <p className="text-gray-600 mb-8">
            Thank you for joining Fudco! Our team will verify your documents and contact you within 24-48 hours.
          </p>

          <div className="bg-yellow-50 p-6 rounded-2xl mb-8">
            <h3 className="font-semibold text-gray-900 mb-3">What's Next?</h3>
            <ul className="text-left text-sm text-gray-600 space-y-2">
              <li className="flex items-start gap-2">
                <CheckCircle className="w-4 h-4 text-[#2D8B2E] mt-0.5 flex-shrink-0" />
                <span>Our team will verify your KYC documents</span>
              </li>
              <li className="flex items-start gap-2">
                <CheckCircle className="w-4 h-4 text-[#2D8B2E] mt-0.5 flex-shrink-0" />
                <span>You'll receive a call for onboarding training</span>
              </li>
              <li className="flex items-start gap-2">
                <CheckCircle className="w-4 h-4 text-[#2D8B2E] mt-0.5 flex-shrink-0" />
                <span>Download our delivery partner app and start earning</span>
              </li>
            </ul>
          </div>

          <div className="flex flex-col sm:flex-row gap-4">
            <Link to="/" className="flex-1">
              <Button variant="outline" className="w-full h-12 rounded-full" data-testid="go-home-btn">
                <Home className="w-4 h-4 mr-2" />
                Go Home
              </Button>
            </Link>
            <Link to="/delivery-partner" className="flex-1">
              <Button className="w-full h-12 bg-[#FFD700] hover:bg-[#e6c200] text-black rounded-full" data-testid="refer-btn">
                <Bike className="w-4 h-4 mr-2" />
                Refer a Friend
              </Button>
            </Link>
          </div>

          <div className="mt-8 pt-6 border-t border-gray-200">
            <p className="text-sm text-gray-500 mb-2">Questions? Contact us</p>
            <a href="mailto:service@fudco.in" className="flex items-center justify-center gap-2 text-[#2D8B2E] font-medium">
              <Mail className="w-4 h-4" />
              service@fudco.in
            </a>
          </div>
        </Card>
      </div>
    </div>
  );
};
